import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, PaginatedResponse, Response } from '@tcc-mono/shared/data-access';
import { PurchaseOrder, PurchaseOrderAnimal, PurchaseOrderAnimalCustom } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobilePurchaseOrderService extends BaseService<PurchaseOrder> {

  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/mobile/purchase_orders';
  }

  public addAnimal = (orderId: number, animal: PurchaseOrderAnimalCustom): Observable<PurchaseOrderAnimal> => {
    return this._http.post<Response<PurchaseOrderAnimal>>(`${this.getUrl(this.path)}/${orderId}/animals`, animal)
      .pipe(
        map(({ data }) => data)
      );
  }

  public getAnimals = (purchaseOrderId: number, params?: Params): Observable<PurchaseOrderAnimal[]> => {
    return this.getChild<PaginatedResponse<PurchaseOrderAnimal>>(purchaseOrderId, 'animals', params)
      .pipe(
        map(({ data }) => data)
      );
  };

  public getAnimal = (purchaseOrderId: string, animalId: PropertyKey): Observable<PurchaseOrderAnimal> => {
    return this.getChild<Response<PurchaseOrderAnimal>>(purchaseOrderId, `animals/${animalId.toString()}`)
      .pipe(
        map(({ data }) => data)
      );
  };

  public updateLine = (orderId: number, orderlineId: number, orderline: PurchaseOrderAnimal): Observable<PurchaseOrderAnimal> => {
    return this._http.put<Response<PurchaseOrderAnimal>>(`${this.getUrl(this.path)}/${orderId}/lines/${orderlineId}`, orderline)
      .pipe(
        map(({ data }) => data)
      );
  }

  public deleteLine = (orderId: number, orderlineId: number): Observable<unknown> => {
    return this._http.delete(`${this.getUrl(this.path)}/${orderId}/lines/${orderlineId}`);
  }
}
